import {
  NavigationContext,
  NavigationProviderProps,
  themes,
  useCallbackRef,
  useNavigationProvider,
} from '@infotech-soe/erp-ui-kit';
import React, { useMemo } from 'react';

import {
  AllowedThemeName,
  FORBIDDEN_THEMES,
  ForbiddenThemeName,
  ThemeName,
} from '../../../../constants/theme';
import { ThemePreferencesPaneContainerProps } from '../ThemePreferencesPaneContainer';

import { useStyles } from './styles';
import ThemeSelectorItem from './ThemeSelectorItem';

interface ThemeSelectorProps extends ThemePreferencesPaneContainerProps {
  rows?: number;
  columns?: number;
}

export const ThemeSelector = ({
  theme,
  rows = 3,
  columns = 1,
  onChangeTheme,
}: ThemeSelectorProps): React.JSX.Element => {
  const classes = useStyles({ rows, columns });

  const themeOptions = useMemo(
    () =>
      (Object.keys(themes) as ThemeName[]).filter(
        (value): value is AllowedThemeName =>
          !FORBIDDEN_THEMES.has(value as ForbiddenThemeName)
      ),
    []
  );

  const navigationProps: NavigationProviderProps = {
    active: theme,
    autoActivate: true,
    columns,
    focusOnActivation: true,
    loop: true,
    onActivate: onChangeTheme as NavigationProviderProps['onActivate'],
  };
  const { ctx, containerProps } = useNavigationProvider(navigationProps);
  const callbackRef = useCallbackRef(containerProps.ref);

  return (
    <div className={classes.container} ref={callbackRef}>
      <NavigationContext.Provider value={ctx}>
        {themeOptions.map(themeName => (
          <ThemeSelectorItem key={themeName} name={themeName} />
        ))}
      </NavigationContext.Provider>
    </div>
  );
};
